/* eslint-disable max-len */
import React from 'react';

export function BoltOffFilled(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M11.5063 9.81834L6.66732 5.00016L9.15239 1.3335H10.4975L9.82495 6.7638H13.8603L11.5063 9.81834Z"
        fill="currentColor"
      />
      <path
        d="M7.33398 14.6668H5.66732L6.46219 10.1577H3.09943L5.45336 6.76381L1.33398 2.8438L2.29237 1.87653L14.6673 14.3662L13.7089 15.3335L9.82495 11.5153L7.33398 14.6668Z"
        fill="currentColor"
      />
    </svg>
  );
}
